// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2qBTK","error":"Textarea_error__1WYWs","readonly":"Textarea_readonly__1lUP-","disabled":"Textarea_disabled__1WRiL"};